import {
  Box,
  Checkbox,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import { Contact } from 'lib/api/contacts/types';
import React from 'react';

interface ContactsProps {
  contacts: Contact[];
  selectedExecutive: any;
  setSelectedExecutive: (executive: any) => void;
  selectedDate: any;
  handleSetSelectedDate: (date: any) => void;
  executivesOptions: any[];
  createExpiredSteps: boolean;
  setCreateExpiredSteps: (createExpiredSteps: boolean) => void;
  selectedContacts: Contact[];
  setSelectedContacts: (contacts: Contact[]) => void;
}

dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  weekStart: 1,
});

const FlowDetails = (props: ContactsProps) => {
  const {
    contacts,
    selectedExecutive,
    setSelectedExecutive,
    selectedDate,
    handleSetSelectedDate,
    executivesOptions,
    createExpiredSteps,
    setCreateExpiredSteps,
    selectedContacts,
    setSelectedContacts,
  } = props;

  const handleContactToggle = (contact: Contact) => {
    const isSelected = selectedContacts.some(
      (selected) => selected.id === contact.id,
    );
    if (isSelected) {
      setSelectedContacts(
        selectedContacts.filter((selected) => selected.id !== contact.id),
      );
    } else {
      setSelectedContacts([...selectedContacts, contact]);
    }
  };

  return (
    <DialogContentText>
      <Typography variant="body2" gutterBottom>
        Contactos a los que se enviaran correos de cobranza (
        {selectedContacts.length}):
      </Typography>

      <Box
        sx={{
          maxHeight: 80,
          overflowY: 'scroll',
          mb: 2,
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#a8a8a8',
          },
        }}
      >
        {contacts.map((contact: Contact) => (
          <FormControlLabel
            key={contact.id}
            control={
              <Checkbox
                checked={selectedContacts.some(
                  (selected) => selected.id === contact.id,
                )}
                onChange={() => handleContactToggle(contact)}
              />
            }
            label={contact.email}
            sx={{ display: 'block' }}
          />
        ))}
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Confirma la siguiente información para enrolar el documento en el flujo
        de cobranza.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel id="flow-label">
              Ejecutivo gestiones manuales
            </InputLabel>
            <Select
              labelId="flow-label"
              id="flow-select"
              value={selectedExecutive}
              onChange={(e) => setSelectedExecutive(e.target.value)}
              label="Ejecutivo gestiones manuales"
            >
              {executivesOptions.map((executive: any) => (
                <MenuItem key={executive.id} value={executive.id}>
                  {executive.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD/MM/YYYY"
                label="Fecha de pago de factura"
                value={selectedDate}
                onChange={(e) => handleSetSelectedDate(e)}
              />
            </LocalizationProvider>
          </FormControl>
        </Grid>
      </Grid>
      <FormControlLabel
        control={
          <Checkbox
            checked={createExpiredSteps}
            onChange={(e) => setCreateExpiredSteps(e.target.checked)}
          />
        }
        label="Crear gestiones cuya fecha de vencimiento es anterior a la fecha actual?"
      />
    </DialogContentText>
  );
};

export default FlowDetails;
